import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminSolar_connections_idHistory_import = z.any()
export type TagsGetAdminSolar_connections_idHistory_import = z.infer<typeof tagsGetAdminSolar_connections_idHistory_import>

export const paramsGetAdminSolar_connections_idHistory_import = z.object({ "id": z.string().uuid() })
export type ParamsGetAdminSolar_connections_idHistory_import = z.infer<typeof paramsGetAdminSolar_connections_idHistory_import>

export const responseGetAdminSolar_connections_idHistory_import = z.object({ "payload": z.union([z.null(), z.object({ "status": z.union([z.literal("pending"), z.literal("complete"), z.literal("failed"), z.literal("cancelled")]), "fromAt": z.string().datetime({ offset: true }), "toAt": z.string().datetime({ offset: true }), "cursorAt": z.string().datetime({ offset: true }), "lastError": z.union([z.string(), z.null()]), "workerHealthy": z.union([z.boolean(), z.null()]), "nextAttemptAt": z.union([z.string().datetime({ offset: true }), z.null()]) })]).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminSolar_connections_idHistory_import = z.infer<typeof responseGetAdminSolar_connections_idHistory_import>

interface IGetAdminSolar_connections_idHistory_import extends BaseMethodType {
  tags: TagsGetAdminSolar_connections_idHistory_import,
  params: ParamsGetAdminSolar_connections_idHistory_import,
  response: ResponseGetAdminSolar_connections_idHistory_import
}
export const tagsPostAdminSolar_connections_idHistory_import = z.any()
export type TagsPostAdminSolar_connections_idHistory_import = z.infer<typeof tagsPostAdminSolar_connections_idHistory_import>

export const paramsPostAdminSolar_connections_idHistory_import = z.object({ "id": z.string().uuid() })
export type ParamsPostAdminSolar_connections_idHistory_import = z.infer<typeof paramsPostAdminSolar_connections_idHistory_import>

export const responsePostAdminSolar_connections_idHistory_import = z.object({ "payload": z.union([z.null(), z.object({ "status": z.union([z.literal("pending"), z.literal("complete"), z.literal("failed"), z.literal("cancelled")]), "fromAt": z.string().datetime({ offset: true }), "toAt": z.string().datetime({ offset: true }), "cursorAt": z.string().datetime({ offset: true }), "lastError": z.union([z.string(), z.null()]), "workerHealthy": z.union([z.boolean(), z.null()]), "nextAttemptAt": z.union([z.string().datetime({ offset: true }), z.null()]) })]).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminSolar_connections_idHistory_import = z.infer<typeof responsePostAdminSolar_connections_idHistory_import>

interface IPostAdminSolar_connections_idHistory_import extends BaseMethodType {
  tags: TagsPostAdminSolar_connections_idHistory_import,
  params: ParamsPostAdminSolar_connections_idHistory_import,
  response: ResponsePostAdminSolar_connections_idHistory_import
}
export const URL = '/admin/solar-connections/:id/history-import'
export const validation = {
  get: {
    tags: tagsGetAdminSolar_connections_idHistory_import,
    params: paramsGetAdminSolar_connections_idHistory_import,
    response: responseGetAdminSolar_connections_idHistory_import
  },
  post: {
    tags: tagsPostAdminSolar_connections_idHistory_import,
    params: paramsPostAdminSolar_connections_idHistory_import,
    response: responsePostAdminSolar_connections_idHistory_import
  }
}
export interface AdminSolar_connections_idHistory_import extends BaseRouteType {
  get: IGetAdminSolar_connections_idHistory_import,
  post: IPostAdminSolar_connections_idHistory_import
}